import React from 'react'
import { useFreeTrial } from '@mc/free-trial'
import { Trans } from '@mc/i18n'
import { PrivacyLink, TermsLink } from '../../links'
import { BaseLink } from '../../links/BaseLink'

export const TrialLegal = ({ className = '' }: { className?: string }) => {
  const { trial } = useFreeTrial()

  return (
    <p className={className}>
      <Trans i18nKey='emailCapture.trial' ns='@mc/legal'>
        <BaseLink href={trial.termsLink} />
        <TermsLink />
        <PrivacyLink />
      </Trans>
    </p>
  )
}
